<template>
  <div
    class="link"
    :style="{
      width: width + 'px',
      height: height + 'px',
    }"
  ></div>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 7
    },
    height: {
      type: Number,
      default: 13
    }
  }
}
</script>
<style lang="scss" scoped>
.link {
  background-image: url("../../assets/right.svg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 7px;
  height: 13px;
  display: inline-block;
}
</style>
